module.exports = {"420302001":"武当路街道","420302002":"二堰街道","420302003":"五堰街道","420302004":"白浪开发区白浪街道","420302100":"大川镇人民政府","420302200":"小川乡","420302201":"茅塔乡","420302202":"鸳鸯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420302.json
// module id = 1717
// module chunks = 0